export enum PAYMENT_DEDUCTION_STATUS {
  OPENED_IN_SYSTEM = 1,
  UNDER_REVIEW = 4,
  APPROVED = 5,
  ON_HOLD = 7,
  REJECTED = 8,
}

export enum BENEFITS_GROUP_STATUS {
  AUTOMATIC = 2,
  PROACTIVE = 3,
  DEDUCTION = 4,
}
